












import ThgListAdmin from "@/components/thg/ThgListAdmin.vue";
import ThgQuoteDetailCard from "@/components/thg/ThgQuoteDetailCard.vue";
import Logo from "@/components/utility/Logo.vue";
import TheLayoutPortalSplit from "@/layouts/TheLayoutPortalSplit.vue";
import { ThgPaginationModule } from "@/store/modules/thg-pagination.store";
import { ThgPortalModule } from "@/store/modules/thg.portal.store";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    TheLayoutPortalSplit,
    Logo,
    ThgListAdmin,
    ThgQuoteDetailCard
  }
})
export default class ThgListAdminView extends Vue {
  loadingSelectedThg = false;

  isLoadingDetailHandler(value: boolean) {
    this.loadingSelectedThg = value;
  }

  loadingAllThgs = false;

  async mounted() {
    await this.load();
  }

  async refresh() {
    await this.load();
  }

  async load() {
    this.loadingAllThgs = true;
    this.loadingSelectedThg = true;

    // no THGs loaded? Fetch!
    try {
      await ThgPaginationModule.fetchAllFromBeginning({});
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.loadingAllThgs = false;
    }

    // Set first item
    try {
      if (ThgPaginationModule.paginationList.length !== 0) {
        await ThgPortalModule.getSelectedThgByPartnerID({
          thgId: ThgPaginationModule.paginationList[0].id,
          partnerId: ThgPaginationModule.paginationList[0].partnerId
        });
        await UserAdministrationModule.getSelectedUser(ThgPaginationModule.paginationList[0].userId);
      }
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.loadingSelectedThg = false;
    }
  }
}
